import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import { Badge } from "@babackapp/ui/components/badge";

/**
 * Worst-case summary of a document's field comparisons, for a table row. The
 * profile holds a person's most recent values, so an older document spelling a
 * name or a phone differently is reported apart from a real gap.
 */
export function PiiStatusCell({
  document,
}: {
  document: PiiLookupDocumentDto;
}) {
  if (!document.isRecordedInVault) {
    return <Badge variant="outline">Pas dans le coffre</Badge>;
  }
  const gaps = document.comparisons.filter(
    (c) => c.status !== "match" && c.status !== "differs_from_profile",
  ).length;
  const hasNewerProfile = document.comparisons.some(
    (c) => c.status === "differs_from_profile",
  );
  if (gaps > 0) {
    return (
      <Badge variant="outline" className="bg-red-100 text-red-800">
        {gaps} écart(s)
      </Badge>
    );
  }
  if (hasNewerProfile) {
    return (
      <Badge
        variant="outline"
        className="bg-slate-100 text-slate-700"
        title="Le client a saisi d'autres valeurs sur un document plus récent : le coffre garde les plus récentes."
      >
        Profil plus récent
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="bg-green-100 text-green-800">
      OK
    </Badge>
  );
}
